<script>
	import { onMount } from 'svelte'
	import { fly, fade } from 'svelte/transition'
	const jq = window.$

	export let data = {}
	// $:console.log(data)
	let self, //!= this.,
		top = 0,
		left = 0,
		width = 0,
		height = 0,
		mouseX = 0,
		mouseY = 0,
		scrolledY = 0,
		mouseLeaveDelay = null

	$: mousePX = mouseX / width
	$: mousePY = mouseY / height
	$: {
		//cardStyle() {
		const rX = mousePX * 30
		const rY = mousePY * -30
		jq(self).css({
			transform: `rotateY(${rX}deg) rotateX(${rY}deg)`, //`rotateY(${rX}deg)`
		})
	}
	$: {
		//cardBgTransform = () => {
		const tX = mousePX * -20
		const tY = mousePY * -20
		jq(self)
			.find('.card-bg')
			.css({
				transform: `scale(1.2) translateX(${tX}px) translateY(${tY}px)`, //translateX(${tX}px)
			})
	}
	$: {
		jq(self)
			.find('.card-bg')
			.css({
				backgroundImage: `url(${data.img})`,
			})
	}

	function handleScroll(e) {
		const ref = self.getBoundingClientRect()
		top = ref.top
		left = ref.left
		scrolledY = window.pageYOffset
	}
	function handleMouseMove(e) {
		mouseX = e.pageX - left - width / 2
		mouseY = e.pageY - scrolledY - top - height / 2
	}
	function handleMouseEnter() {
		clearTimeout(mouseLeaveDelay)
	}
	function handleMouseLeave() {
		mouseLeaveDelay = setTimeout(() => {
			mouseX = 0
			mouseY = 0
		}, 350)
	}

	function handleResize() {
		const ref = self.getBoundingClientRect()
		top = ref.top
		left = ref.left
		width = ref.width
		height = ref.height
		scrolledY = window.pageYOffset
	}

	onMount(function () {
		jq(document).on('scroll', handleScroll)
		jq(window).on('resize', handleResize)
		handleResize()
	})
</script>

<div
	class="card-wrap"
	on:mousemove={handleMouseMove}
	on:mouseenter={handleMouseEnter}
	on:mouseleave={handleMouseLeave}
	top={100}
	once
>
	<a href={data.url}
		><span class="sr-only">Go To {@html data.postTitle} page</span></a
	>
	<div
		class="card"
		transition:fly={{ y: 20, duration: 650, delay: 0.1 }}
		bind:this={self}
		data-style="cardStyle"
	>
		<div class="card-bg" data-style="[cardBgTransform, cardBgImage]" />
		<div class="card-info">
			<!-- <slot name="header"></slot> -->
			<h3 data-slot="header">{@html data.postTitle}</h3>
			<!-- <slot name="content"></slot> -->
			<p data-slot="content">
				{#if data.categories.length}
					<span>{@html data.categories[0]}</span>
				{/if}
				{#if data.categories.length && data.locations.length}
					<span class="divider">|</span>
				{/if}
				{#if data.locations.length}
					<span>{@html data.locations[0]}</span>
				{/if}
			</p>
		</div>
	</div>
</div>
